import React from "react";
import logoProtmar from "../../media/logoProtmar.jpg";
import "./BaseMenuPrincipal.scss";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useState } from "react";

const BaseMenuPrincipal = (props: any) => {
    const location = useLocation();

    const getIconStatusColor = (page: string) => {
        if (location.pathname === page) {
            return { backgroundColor: "#14D537" };
        }
        return {};
    };

    const handleBackupClick = async (tableName: "entradas" | "saidas" | "anexos" | "logins") => {
        try {
            const token = localStorage.getItem("token"); // ou de onde estiver guardando o token
            
            const response = await fetch(`https://financeiro.api.protmar.com.br/backup/${tableName}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`, // Adiciona o token no cabeçalho
                },
            });
    
            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `backup_${tableName}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } else {
                console.error('Erro ao gerar o backup');
            }
        } catch (error) {
            console.error('Erro ao fazer o download do backup:', error);
        }
    };
    

    return (
        <main id="BMPMain" className="container-fluid">
            <section id="BMPprincipalSection" className="row">
                <div id="BMPLadoEsquerdo" className="col-12 col-md-4 d-flex justify-content-center">
                    <div id="BMPcontainerInfoEsquerdo">

                        <Link className="BMPLinkRotas" to="/">
                            <img id="logoLadoEsquerdo" src={logoProtmar} alt="" />
                        </Link>
                        

                        <Link id="ILMain" className="BMPLinkRotas" to="/resumogeral">
                            <div id="ILMain">
                                <div id="ILIconeStatusJanela" style={getIconStatusColor("/resumogeral")}></div>
                                <div className="BMPLinkRotas">Resumo Geral</div>
                            </div>
                        </Link>

                        <Link id="ILMain" className="BMPLinkRotas" to="/entradas">
                            <div id="ILMain">
                                <div id="ILIconeStatusJanela" style={getIconStatusColor("/entradas")}></div>
                                <div className="BMPLinkRotas">Entradas</div>
                            </div>
                        </Link>

                        <Link id="ILMain" className="BMPLinkRotas" to="/saidas">
                            <div id="ILMain">
                                <div id="ILIconeStatusJanela" style={getIconStatusColor("/saidas")}></div>
                                <div className="BMPLinkRotas">Saídas</div>
                            </div>
                        </Link>

                        {/* <Link id="ILMain" className="BMPLinkRotas" to="/funcionarios">
                            <div id="ILMain">
                                <div id="ILIconeStatusJanela" style={getIconStatusColor("/funcionarios")}></div>
                                <div className="BMPLinkRotas">Funcionarios</div>
                            </div>
                        </Link> */}



                        

                        <Link id="ILMain" className="BMPLinkRotas" to="/configuracoes">
                            <div id="ILMain">
                                <div id="ILIconeStatusJanela" style={getIconStatusColor("/configuracoes")}></div>
                                <div className="BMPLinkRotas">Configurações</div>
                            </div>
                        </Link>

                        <button className="btn btn-primary" onClick={async () => {
                            await handleBackupClick("entradas");
                            await handleBackupClick("saidas");
                            await handleBackupClick("anexos");
                            await handleBackupClick("logins")
                        }}>Criar Backup</button>
                    </div>
                </div>

                <div id="BMPLadoDireito" className="col-12 col-md-8 d-flex justify-content-center align-items-center">
                    {props.botoes}
                    {props.InfoLateral}
                    <img id="logoLadoDireito" src={logoProtmar} alt="Logo da Protmar" />
                </div>
            </section>
        </main>
    );
}

export default BaseMenuPrincipal;
